module.exports = "/assets/554a58fddf2dc81873f93da6b66faf4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9F.png
// module id = 2288
// module chunks = 0